@if (isLoggedIn) {
  <core-banner-notification></core-banner-notification>
}
<header role="banner" class="flex">
  @if (menuItems) {
    <core-header
      [items]="menuItems"
      [imagePath]="imagePath"
      class="flex-1"
    ></core-header>
  }
  <div class="flex mr-2 mt-3">
    @if (products.length > 0 && isAppLauncherWidgetFeatureEnabled) {
      <products-widget-component
        class="mr-2 mt-2"
        [products]="products"
        [imagePathUrl]="imagePathUrl"
      ></products-widget-component>
    }
    @if (isAppLoaded) {
      <a
        href="#"
        class="menu-item menu-link mt-2"
        (click)="logout(); $event.preventDefault()"
      >
        Logout
      </a>
    }
  </div>
</header>
<core-session-timer></core-session-timer>
<main role="main">
  <div class="col-12 col-nogutter grid page-layout">
    <div class="col-12">
      @if (isLoggedIn) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>
</main>
<footer>
  @if (isLoggedIn) {
    <core-footer [copyrightDetail]="copyrightModel"></core-footer>
  }
</footer>
@if (isLoading) {
  <core-spin-loader></core-spin-loader>
}
<app-user-registration></app-user-registration>
@if (__URL === "/register-user") {
  <core-register-user></core-register-user>
}
